import React, { useEffect, useRef } from 'react'
// @ts-ignore
// Lottie 라이브러리의 경량 버전을 임포트합니다.
import lottie from 'lottie-web/build/player/lottie_light.min.js'
/**  */

/** Lottie 컴포넌트의 프로퍼티 타입을 정의합니다. */
interface LottieProps {
  width?: string // 애니메이션의 너비
  height?: string // 애니메이션의 높이
  json: string // 애니메이션 데이터(JSON 객체)
  options?: LottieOptions // Lottie 옵션
  isHover?: boolean // 마우스 호버 상태
  className?: string // 커스텀 CSS 클래스 이름
  style?: React.CSSProperties // 인라인 스타일
  lottieRef?: React.RefObject<any> // Lottie 애니메이션 인스턴스에 대한 참조
}

/** Lottie 옵션의 타입을 정의합니다. */
interface LottieOptions {
  renderer?: 'svg' | 'canvas' // 렌더러 타입
  loop?: boolean // 반복 여부
  autoplay?: boolean // 자동 재생 여부
  speed?: number // 재생 속도
  rendererSettings?: any // 렌더러 설정
  hoverplay?: boolean // 호버 시 재생 여부
}

export default function Lottie({
  width,
  height,
  json,
  isHover,
  options = {},
  className,
  style,
  lottieRef,
}: LottieProps) {
  const containerRef = useRef<HTMLDivElement>(null!)
  const animationRef = useRef<any>(null!)

  useEffect(() => {
    // Lottie 애니메이션을 초기화하고, 설정된 옵션에 따라 애니메이션을 로드합니다.
    animationRef.current = lottie.loadAnimation({
      container: containerRef.current,
      animationData: json,
      renderer: options.renderer ?? 'svg',
      loop: options.loop ?? true,
      autoplay: options.autoplay ?? true,
      rendererSettings: options.rendererSettings ?? {
        preserveAspectRatio: 'xMidYMid slice',
      },
    })
    // 설정된 속도로 애니메이션 속도를 설정합니다.
    options.speed && animationRef.current.setSpeed(options.speed)
    // lottieRef가 제공되면, 이를 통해 애니메이션 인스턴스에 접근할 수 있도록 합니다.
    if (lottieRef) {
      // @ts-ignore
      lottieRef.current = animationRef.current
    }
    // 컴포넌트가 언마운트될 때 애니메이션 인스턴스를 파괴합니다.
    return () => animationRef.current.destroy()
  }, [])

  /** hoverplay 옵션이 활성화되어 있고, isHover 상태에 따라 애니메이션을 재생하거나 정지 */
  useEffect(() => {
    if (!options.hoverplay) return
    isHover ? animationRef.current.play() : animationRef.current.stop()
  }, [isHover])

  return (
    <div
      ref={containerRef}
      className={className}
      style={{ width: width ?? '100%', height: height ?? '100%', ...style }}
    />
  )
}
